import request from '@/utils/request'

function call(url, method, payload) {
  return request({
    url,
    method,
    ...(method === 'get' ? { params: { ...(payload || {}) } } : { data: payload || {} })
  }).then(response => {
    const result = response.data
    if (result && result.code !== undefined && Number(result.code) !== 0) {
      const message = result.msg && result.msg !== 'null' ? result.msg : '线下收款接口请求失败'
      const error = new Error(message)
      error.result = result
      throw error
    }
    return result
  })
}

export function listOfflineCollectionOrders(params) {
  return call('/offlineCollection.listOrders', 'get', params)
}

export function getOfflineCollectionOrder(params) {
  return call('/offlineCollection.getOrder', 'get', params)
}

export function listOfflineCollectionEvents(params) {
  return call('/offlineCollection.listPaymentEvents', 'get', params)
}

export function createOfflineCollectionRefund(data) {
  return call('/offlineCollection.createRefundRequest', 'post', data)
}

export function listOfflineCollectionRefunds(params) {
  return call('/offlineCollection.listRefunds', 'get', params)
}

export function getOfflineCollectionRefund(params) {
  return call('/offlineCollection.getRefund', 'get', params)
}

export function reviewOfflineCollectionRefund(data) {
  return call('/offlineCollection.reviewRefund', 'post', data)
}

export function listOfflineCollectionPoints(params) {
  return call('/offlineCollection.listPoints', 'get', params)
}

export function saveOfflineCollectionPoint(data) {
  const payload = { ...(data || {}) }
  if (payload.scopeType === 'PROPERTY') payload.communityId = null
  if (!Array.isArray(payload.paymentPoolIds) && payload.paymentPoolId) payload.paymentPoolIds = [payload.paymentPoolId]
  if (Array.isArray(payload.paymentPoolIds) && payload.paymentPoolIds.length) payload.paymentPoolId = payload.paymentPoolIds[0]
  delete payload.wechatAppId
  delete payload.huaweiAppId
  return call('/offlineCollection.savePoint', 'post', payload)
}

export function updateOfflineCollectionPoint(data) {
  const payload = { ...(data || {}) }
  if (payload.scopeType === 'PROPERTY') payload.communityId = null
  if (!Array.isArray(payload.paymentPoolIds) && payload.paymentPoolId) payload.paymentPoolIds = [payload.paymentPoolId]
  delete payload.propertyCompanyId
  delete payload.entryUrl
  delete payload.entryUrlDisplay
  delete payload.entryUrlPrefix
  delete payload.entryToken
  delete payload.entryTokenHash
  delete payload.entryHash
  delete payload.wechatAppId
  delete payload.huaweiAppId
  delete payload.appId
  return call('/offlineCollection.updatePoint', 'post', payload)
}

export function regenerateOfflineCollectionPointCode(data) {
  return call('/offlineCollection.regeneratePointCode', 'post', data)
}
